import { Props_SnippetParagraph } from './Paragraph.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetParagraph = (props: Props_SnippetParagraph) => {
    const {size, backgroundColour, textAlignment, textColour, width, textWrap, text} = props.paragraph

     // Don't render if no text content
    if (!text.value?.trim()) return null

    const sizeClass = size?.value ? `snippet-paragraph--${size.value}` : ''
    const backgroundColourClass = backgroundColour?.value ? `snippet-paragraph--bg--${backgroundColour.value}` : ''
    const alignmentClass = textAlignment?.value ? `snippet-paragraph--align-${textAlignment.value}` : ''
    const textColourClass = textColour?.value ? `snippet-paragraph--text-${textColour.value}` : ''
    const widthClass = width?.value ? `snippet-paragraph--width-${width.value}` : ''
    const textWrapClass = textWrap?.value ? `snippet-paragraph--text-wrap-${textWrap.value}` : ''


    const paragraphClasses = [
        'snippet-paragraph',
        sizeClass,
        backgroundColourClass,
        alignmentClass,
        textColourClass,
        widthClass,
        textWrapClass,
    ].join(' ')



    return (
        <section className={paragraphClasses}>
            <div className="snippet-paragraph__container">
                <div className="snippet-paragraph__content">
                        {CompileMarkdown(text.value!)} 
                </div>
            </div>
        </section>
    )
}

export default SnippetParagraph
